import { render, staticRenderFns } from "./NsPhoneNumber.vue?vue&type=template&id=03e5a0c4&scoped=true&"
import script from "./NsPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./NsPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./NsPhoneNumber.vue?vue&type=style&index=0&id=03e5a0c4&lang=scss&scoped=true&"
import style1 from "./NsPhoneNumber.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e5a0c4",
  null
  
)

export default component.exports